import React from "react";
import {
  Avatar,
  Box,
  Flex,
  Text,
  useColorModeValue,
  Icon,
  Button,
} from "@chakra-ui/react";
import { FaEnvelope, FaPhone } from "react-icons/fa"; // Importing icons
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import ReusableAvatar from "components/Avatar/ReusableAvatar";

const UserCard = ({ name, email, phone, cellphone, isLoading, onChatClick }) => {
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Flex
      direction="column"
      borderRadius="15px"
      boxShadow="md"
      p="20px"
      backgroundColor={useColorModeValue("white", "gray.800")}
      minHeight="100px"
      flex="1" // Allow the card to grow within its container
    >
      <Flex direction="row" mb="20px" align="center">
        {isLoading ? (
          <Skeleton circle={true} height="48px" width="48px" />
        ) : (
          <ReusableAvatar
            name={name} 
            size="md"
            mr="15px"
          />
        )}
        <Flex direction="column" ml={isLoading ? "15px" : "0"}>
          <Text fontSize="md" color={textColor} fontWeight="bold">
            {isLoading ? <Skeleton width="120px" /> : name}
          </Text>
          <Flex alignItems="center">
            <Icon as={FaEnvelope} mr={2} color="gray.400" />
            <Text fontWeight="500" color="gray.500" fontSize="sm">
              {isLoading ? <Skeleton width="180px" /> : email}
            </Text>
          </Flex>
        </Flex>
      </Flex>

      <Box mb="20px">
        <Flex alignItems="center">
          <Icon as={FaPhone} mr={2} color="gray.400" />
          <Text fontWeight="500" color="gray.500" fontSize="sm">
            {isLoading ? <Skeleton width="140px" /> : cellphone}
          </Text>
        </Flex>
      </Box>
      <Flex justifyContent="flex-end">
        <Button
          variant="outline"
          borderColor="#071D54" 
          color="#071D54"
          minW="90px"
          h="36px"
          fontSize="xs"
          px="1.5rem"
          borderRadius="7px"
          _hover={{ bg: "#051a47", borderColor: "#051a47", color: "white" }} 
          onClick={onChatClick}
        >
          Chat
        </Button>
      </Flex>
    </Flex>
  );
};

export default UserCard;
